import { render, staticRenderFns } from "./planet.svg.vue?vue&type=template&id=a6bc1ff2&"
import script from "./planet.svg.vue?vue&type=script&lang=js&"
export * from "./planet.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports